export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  readCount: number;
  imageSeq: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2026世界杯预选赛亚洲区12强赛完整赛程与出线形势分析',
    summary: '2026年世界杯预选赛亚洲区12强赛激战正酣，本文为您详细解析各小组出线形势、关键战役及各大豪门球队的最新动态。',
    content: `<p>2026年世界杯预选赛亚洲区12强赛已经进入白热化阶段。随着赛程的推进，各小组的出线形势逐渐明朗。本文将为大家带来最新、最全面的赛事分析。</p>
<h3>A组形势分析</h3>
<p>A组目前竞争异常激烈。伊朗队凭借稳定发挥暂居榜首，韩国队紧随其后。两支传统强队展现了亚洲足球的顶级水平。阿联酋和伊拉克则在为附加赛名额展开激烈争夺。</p>
<p>伊朗队在已经进行的6场比赛中取得了4胜2平的不败战绩，攻入12球仅失3球，攻防两端均展现出极高水准。韩国队同样表现不俗，孙兴慜领衔的进攻线给对手防线带来了极大威胁。</p>
<h3>B组焦点战役</h3>
<p>B组的争夺更加白热化。日本队和澳大利亚队实力相当，两队直接对话的结果很可能决定小组头名归属。沙特阿拉伯队则成为最大黑马，凭借出色的团队配合在小组中保持强劲竞争力。</p>
<p>日本队在本届预选赛中展现了深厚的人才储备，多名旅欧球员的出色发挥为球队注入了强大动力。三笘薫、久保建英等年轻球员的崛起让日本队的攻击线更加立体多变。</p>
<h3>关键战役前瞻</h3>
<p>下一轮比赛中，伊朗对阵韩国、日本对阵澳大利亚的两场焦点战将直接决定各自小组的榜首位置。这些比赛的赔率变化和赛前分析值得重点关注。开云体育平台将为您提供最实时、最准确的赛事赔率和专业解读。</p>`,
    category: '足球',
    categorySlug: 'football',
    author: '开云体育编辑部',
    date: '2026-08-06',
    readCount: 12850,
    imageSeq: 'article-wcq-2026',
    tags: ['世界杯', '预选赛', '亚洲足球', '伊朗', '韩国', '日本'],
  },
  {
    id: 'article-2',
    title: 'NBA新赛季前瞻：东部群雄并起，西部豪门争霸格局深度解读',
    summary: 'NBA新赛季即将拉开大幕，东部多支球队完成补强，西部传统豪门蓄势待发。本文从转会市场、球队实力、赛程难度等多维度进行深度分析。',
    content: `<p>随着新赛季训练营的临近，NBA各支球队的阵容调整已基本完成。经过一个夏天的转会运作，联盟格局发生了显著变化。</p>
<h3>东部联盟：群雄并起新时代</h3>
<p>波士顿凯尔特人作为卫冕冠军，核心阵容保持稳定。塔图姆和布朗的双探花组合依然是联盟最具威胁的攻击搭档。而密尔沃基雄鹿在休赛期完成关键补强，字母哥迎来了更强力的帮手。</p>
<p>费城76人、纽约尼克斯和克利夫兰骑士等球队同样不容小觑。东部的竞争激烈程度达到了近年来的顶峰，每支季后赛球队都具备冲击分区决赛的实力。</p>
<h3>西部联盟：传统豪门与新势力的碰撞</h3>
<p>西部方面，丹佛掘金在约基奇的带领下依然是最具冠军相的球队。但俄克拉荷马雷霆的年轻核心阵容经过上赛季的磨合更加成熟，亚历山大已经成为MVP级别球员。</p>
<p>金州勇士在休赛期进行了阵容年轻化改造，库里依然是球队的灵魂。洛杉矶湖人则在新教练的带领下寻求战术革新，勒布朗和戴维斯的组合依然是联盟最具统治力的内外搭档。</p>
<h3>新赛季看点总结</h3>
<p>新赛季的NBA将呈现更加多元化的竞争格局。开云体育平台将持续为球迷带来最新的NBA赛事资讯、实时数据和专业分析，助您全面把握新赛季动态。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    author: '开云体育编辑部',
    date: '2026-08-05',
    readCount: 9620,
    imageSeq: 'article-nba-preview',
    tags: ['NBA', '篮球', '赛季前瞻', '凯尔特人', '掘金'],
  },
  {
    id: 'article-3',
    title: '温网2026男单决赛回顾：史诗级五盘大战缔造经典',
    summary: '2026年温布尔登网球锦标赛男单决赛上演史诗级对决，两位世界顶尖选手经过五个小时的鏖战，为全球网球迷奉献了一场永载史册的经典比赛。',
    content: `<p>2026年温布尔登网球锦标赛男单决赛在中央球场落下帷幕。这场耗时超过五小时的史诗对决，将长久留存在每一位网球迷的记忆中。</p>
<h3>比赛进程回顾</h3>
<p>首盘比赛，双方迅速进入状态，各自保住发球局后将比赛拖入抢七。抢七局中，头号种子凭借更加稳定的底线发挥以7-4拿下首盘。第二盘，二号种子调整战术，加强网前进攻频率，以6-3扳回一城。</p>
<p>第三盘成为整场比赛的转折点。头号种子在2-5落后的情况下连追四局，最终在抢七中以8-6艰难胜出。第四盘，二号种子展现强大心理素质，以6-4将比赛拖入决胜盘。</p>
<p>决胜盘中，双方体力均接近极限，但精神层面的较量更加激烈。最终头号种子在第12局完成关键破发，以7-5锁定胜局，捧起个人第四座温网冠军奖杯。</p>
<h3>技术统计亮点</h3>
<p>整场比赛，两位选手共轰出142记制胜分，ACE球数量达到惊人的47个。头号种子的一发得分率高达78%，而二号种子的网前得分率也达到了72%的优异水平。</p>`,
    category: '网球',
    categorySlug: 'tennis',
    author: '开云体育编辑部',
    date: '2026-08-04',
    readCount: 7540,
    imageSeq: 'article-wimbledon-2026',
    tags: ['温网', '网球', '大满贯', '男单决赛'],
  },
  {
    id: 'article-4',
    title: '英雄联盟S16全球总决赛：LPL赛区四强战队实力分析与夺冠前景',
    summary: '英雄联盟S16全球总决赛即将开战，LPL赛区四支参赛队伍已经全部确定。本文从战队实力、选手状态、版本适应等多角度分析各队的夺冠前景。',
    content: `<p>随着LPL夏季赛的结束，代表LPL赛区出征S16全球总决赛的四支战队已经全部确定。作为卫冕赛区，LPL今年依然保持着极强的竞争力。</p>
<h3>一号种子：夏季赛冠军战队</h3>
<p>作为LPL夏季赛冠军，这支战队在整个赛季展现了统治级的表现。中野组合的默契配合是球队最强大的武器，而下路双人组在季后赛中更是打出了MVP级别的发挥。版本变动对他们影响较小，因为选手英雄池深度足够应对各种战术体系。</p>
<h3>二号种子：积分最高战队</h3>
<p>凭借全年稳定的发挥，二号种子以最高积分晋级。他们的打法以团队协作著称，运营能力在LPL首屈一指。虽然在夏季赛决赛中惜败，但他们在外战中的经验更加丰富，面对国际赛事的适应能力值得期待。</p>
<h3>三号和四号种子：冒泡赛突围战队</h3>
<p>两支通过冒泡赛晋级的战队同样不容小觑。三号种子在冒泡赛中展现了极强的韧性，连续两场让二追三的逆转令人印象深刻。四号种子则是一支年轻战队，打法激进富有创造力，可能成为本届赛事的最大黑马。</p>
<h3>S16夺冠前景展望</h3>
<p>LPL赛区整体实力依然处于全球领先地位，但LCK赛区的挑战同样不容忽视。开云体育平台将为电竞爱好者提供S16全程赛事资讯和实时数据，敬请关注。</p>`,
    category: '电竞',
    categorySlug: 'esports',
    author: '开云体育编辑部',
    date: '2026-08-03',
    readCount: 11230,
    imageSeq: 'article-lol-s16',
    tags: ['英雄联盟', 'S16', 'LPL', '全球总决赛', '电竞'],
  },
  {
    id: 'article-5',
    title: '欧冠小组赛抽签结果出炉：死亡之组再现，豪门对决一触即发',
    summary: '2026-2027赛季欧冠联赛小组赛抽签仪式在摩纳哥举行，多个小组出现强强对话，死亡之组再度成为球迷关注的焦点。',
    content: `<p>2026-2027赛季欧洲冠军联赛小组赛抽签仪式在摩纳哥格里马尔迪论坛圆满结束。32支晋级球队各就各位，多个小组的强强对话引发全球球迷热议。</p>
<h3>A组：卫冕冠军遭遇强敌</h3>
<p>卫冕冠军皇家马德里被分入A组，同组对手包括意甲劲旅国际米兰和葡超豪门波尔图。三支球队都具备欧冠淘汰赛级别的实力，堪称本届赛事最具看点的小组之一。</p>
<h3>C组：英超双雄狭路相逢</h3>
<p>C组汇聚了曼城和多特蒙德两支攻击力极强的球队。瓜迪奥拉的传控体系遇上多特蒙德的高位逼抢，两种风格的碰撞必将带来精彩对决。同组的AC米兰同样虎视眈眈，使得该组的出线形势更加扑朔迷离。</p>
<h3>各组出线形势初判</h3>
<p>从整体抽签结果来看，英超和西甲球队的分组相对有利，而意甲球队则面临更为严峻的考验。不过欧冠的魅力就在于其不可预测性，每个赛季都会有黑马球队突出重围。开云体育平台将持续跟踪欧冠赛事动态，为您带来全方位的赛事体验。</p>`,
    category: '足球',
    categorySlug: 'football',
    author: '开云体育编辑部',
    date: '2026-08-02',
    readCount: 8910,
    imageSeq: 'article-ucl-draw',
    tags: ['欧冠', '足球', '抽签', '皇马', '曼城'],
  },
  {
    id: 'article-6',
    title: '开云体育平台新用户注册指南：三步完成账号开通与首存优惠领取',
    summary: '为帮助新用户快速完成开云体育平台注册和首存优惠领取，本文提供详细的注册流程指南和常见问题解答。',
    content: `<p>欢迎加入开云体育平台！为帮助您快速上手，本文提供详细的注册流程和优惠领取指南。</p>
<h3>第一步：访问开云体育平台官网</h3>
<p>通过浏览器访问开云体育平台官方网站，点击页面右上角的"注册"按钮进入注册页面。建议使用Chrome、Safari等主流浏览器以获得最佳体验。</p>
<h3>第二步：填写注册信息</h3>
<p>在注册页面填写您的手机号码或电子邮箱地址，设置安全密码。请确保密码包含大小写字母和数字，长度在8-20位之间。填写完成后，输入手机验证码完成身份验证。</p>
<h3>第三步：领取新人专属优惠</h3>
<p>注册成功后，进入"个人中心-优惠活动"页面即可查看新人专属优惠。开云体育平台为新用户准备了丰厚的首存优惠和体育竞猜体验金，助您开启精彩体育之旅。</p>
<h3>常见问题</h3>
<p>Q: 注册需要提供哪些资料？A: 仅需手机号或邮箱即可完成注册。</p>
<p>Q: 一个人可以注册多个账号吗？A: 为确保平台公平性，每位用户仅限注册一个账号。</p>`,
    category: '综合',
    categorySlug: 'others',
    author: '开云体育客服中心',
    date: '2026-08-01',
    readCount: 15670,
    imageSeq: 'article-register-guide',
    tags: ['注册指南', '新用户', '优惠活动', '开云体育'],
  },
  {
    id: 'article-7',
    title: '中超联赛下半程看点：争冠集团白热化，保级大战悬念丛生',
    summary: '2026赛季中超联赛进入下半程争夺，争冠集团多支球队积分紧咬，保级区同样有多支球队陷入苦战。',
    content: `<p>2026赛季中超联赛已经进行到第18轮，赛程过半后各队的真实实力已经充分展现。与上赛季相比，本赛季的中超呈现出更加激烈的竞争格局。</p>
<h3>争冠集团分析</h3>
<p>目前积分榜前四名的球队积分差距在5分以内，争冠形势异常胶着。卫冕冠军上海海港虽然仍居榜首，但近期状态有所起伏。紧随其后的山东泰山和北京国安均展现了强劲的追赶势头。</p>
<p>上海海港本赛季引援力度较大，奥斯卡和武磊的组合依然是中超最具威胁的进攻搭档。山东泰山则依靠整体实力和深厚的板凳深度保持稳定输出。</p>
<h3>保级大战</h3>
<p>积分榜后五名的球队积分差距仅4分，保级形势扑朔迷离。多支传统劲旅陷入保级泥潭，接下来的每一场比赛都可能成为生死战。开云体育平台将持续关注中超赛事动态，为球迷带来最新赛况和分析。</p>`,
    category: '足球',
    categorySlug: 'football',
    author: '开云体育编辑部',
    date: '2026-07-30',
    readCount: 6230,
    imageSeq: 'article-csl-midseason',
    tags: ['中超', '足球', '争冠', '保级'],
  },
  {
    id: 'article-8',
    title: 'FIBA篮球世界杯预选赛：中国男篮新阵容磨合初见成效',
    summary: '中国男篮在FIBA篮球世界杯预选赛窗口期比赛中展现全新面貌，新教练带来的战术体系和新球员的加入让球队焕发活力。',
    content: `<p>在刚刚结束的FIBA篮球世界杯预选赛窗口期比赛中，中国男篮以全新阵容出战，取得了令人满意的成绩。</p>
<h3>新教练新战术</h3>
<p>新任主教练带来的欧式战术体系让中国男篮的打法更加现代化。强调空间利用和快速转移球的理念，让球队的进攻流畅度较之前有了明显提升。防守端，更加激进的换防策略也在比赛中收获了积极效果。</p>
<h3>年轻球员崭露头角</h3>
<p>多名年轻球员在本期国家队中获得了展示机会，其中几位新人的表现尤为亮眼。他们不仅在进攻端提供火力支持，在防守端也展现了超出年龄的成熟度。这些年轻血液的注入为中国男篮的未来发展奠定了良好基础。</p>
<h3>世界杯前景展望</h3>
<p>从目前的表现来看，中国男篮正处于积极的重建轨道上。虽然距离世界顶级强队还有一定差距，但团队凝聚力和战术执行力的提升有目共睹。期待在接下来的预选赛和正赛中，中国男篮能够继续进步。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    author: '开云体育编辑部',
    date: '2026-07-28',
    readCount: 5180,
    imageSeq: 'article-fiba-china',
    tags: ['FIBA', '篮球', '中国男篮', '世界杯预选赛'],
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};